import React from "react";
import { hasAccess } from "../js/authProvider";
import { I18n } from "react-redux-i18n";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

export const CanAccess = ({ rbac, resource, children, fallback = null }) => {

    if (resource instanceof Array === false) {
        const allowed = hasAccess(resource, rbac);
        return allowed ? <>{children}</> : fallback ? fallback : children ? (<React.Fragment></React.Fragment>) : false;
    } else {
        const allowed = resource.some(res => hasAccess(res, rbac));
        return allowed ? <>{children}</> : fallback ? fallback : children ? (<React.Fragment></React.Fragment>) : false;
    }
};

export const CanAccessPage = ({ action, type, resource, children, fallback = null }) => {

    const allowed = hasAccess(action, type, resource);

    return allowed ? <>{children}</> : fallback ? fallback : <div style={{ position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)", fontSize: "30px" }}>🚫 {I18n.t("admin_local.Access denied")}</div>;;
};


const mapStateToProps = (props, state) => {
    if (props.rootReducer.myStatus && props.rootReducer.myStatus.restaurant_id) {
        return {
            ...props,
            rbac: props.rootReducer.rbac,
        };
    }
    return {};
};

export default connect(mapStateToProps)(withRouter(CanAccess));